import React from "react"
import ReactDOM from "react-dom"
import ImageListGridCarousel from "./image-list-grid-carousel-component"

export default class ImageListGridCarouselModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ImageListGridCarousel {...self.modelJson} />, self.elem)
  }
}
